import React from 'react';
import Image from 'next/image';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Head from 'next/head';

import { GetServerSideProps } from 'next';

interface LandingPageProps {
  userTimezone: string;
  userCity: string | null;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const userTimezone = context.req.headers['x-vercel-ip-timezone'] as string || 'GMT';
  const userCity = context.req.headers['x-vercel-ip-city'] as string || null;

  return {
    props: {
      userTimezone,
      userCity,
    },
  };
};

const LandingPage: React.FC<LandingPageProps> = ({userCity, userTimezone}) => {
  const eventTimeGMT = '2023-11-27T09:00:00Z';

  // Convert to user's local time
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long', // e.g., Monday
    year: 'numeric', // e.g., 2023
    month: 'long', // e.g., November
    day: 'numeric', // e.g., 20
    hour: 'numeric', // e.g., 9 AM
    minute: '2-digit', // e.g., 00
    timeZoneName: 'short', // e.g., GMT
    timeZone: userTimezone,
  };

  const eventTimeLocal = new Date(eventTimeGMT).toLocaleString('en-US', options);

  return (
    <>
      <Head>
        <title>IELTS Speaking Exam Simulation Event</title>
      <meta name="description" content="Join our IELTS Speaking Exam Simulation Event on Nov 27th for an immersive experience. Engage with a speaking buddy matched to your level and sharpen your skills in a realistic exam environment. Perfect for those preparing for IELTS and seeking comprehensive speaking practice. Sign up now to transform your preparation." />

      </Head>
      <Header />
      <main className="container mx-auto px-4">
        <section className="text-center py-10">
          <h1 className="text-5xl font-bold text-gray-800">IELTS speaking test simulation</h1>
          <h3 className="text-3xl font-bold text-gray-800">Online Event</h3>
          <p className="text-xl text-gray-600 mt-2">{eventTimeLocal} {userCity && `(${userCity} time)`}</p>

          <a href="https://www.videoask.com/ffni3243b" className="inline-block mt-4 px-6 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition duration-300">Sign up for an Event</a>
        </section>

        <section className="my-10">
          <h2 className="text-3xl text-gray-800 font-semibold text-center">Why Participate?</h2>
          <div className="flex flex-col items-center mt-6">
            <div className="w-full max-w-2xl bg-white shadow-lg rounded-lg p-6">
              <ul className="list-disc text-left text-gray-600">
                <li>Engage in a realistic IELTS speaking exam simulation with peers matched to your level.</li>
                <li>Experience both roles: the examiner and the test taker, to understand the exam from both perspectives.</li>
                <li>Practice with questions that closely mirror the actual IELTS exam content.</li>
                <li>Receive resources and detailed instructions via email to prepare effectively for the event.</li>
                <li>Sharpen your skills with provided sample questions and answers before the event.</li>
                <li>Complete a typical exam cycle in 11-14 minutes, just like the real test.</li>
              </ul>
            </div>
          </div>
        </section>

        {/* ... Other sections for additional information like testimonials, FAQs, contact information */}
      </main>
      <Footer />
    </>
  );
};

export default LandingPage;

